import {IonApp, isPlatform, setupIonicReact} from '@ionic/react';
import React from "react";
import MainRouter from "./routers/MainRouter";
import {ThemeProvider} from "@mui/material";
import {fonrocheTheme} from "./theme/Theming";
import {StatusBar} from "@capacitor/status-bar";

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/global.css';
import { KEY_FOR_HYBRID_PLATFORM } from './services/UtilsService';

setupIonicReact();

/**
 * The root component.
 * This is the first React component and will be used in the bootstrapping process for our React app.
 * @author Alizée Grand
 * @version 1.2
 * @creation 09/04/2021
 * @last_update 04/01/2022
 **/
class App extends React.Component {

    /**
     * Is executed after the component output has been injected into the DOM.
     * Display the app in full screen on mobile.
     * @returns {Promise<void>}
     */
    async componentDidMount() {
        if(isPlatform(KEY_FOR_HYBRID_PLATFORM)) {
            await StatusBar.hide();
        }
    }

  render() {

    return (
        // Injects the custom material design into the whole application
        <ThemeProvider theme={fonrocheTheme}>
          <IonApp>
            <MainRouter/>
          </IonApp>
        </ThemeProvider>
    );
  }
}

export default App;
